import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { ChevronDown } from "lucide-react";
 * // Use <ChevronDown /> instead
 */
export const ArrowDownIcon = createSVGWrapper(
  <path
    fill="currentColor"
    d="M15.932 10H8.067a.5.5 0 0 0-.384.82l3.933 4.72a.5.5 0 0 0 .768 0l3.933-4.72a.5.5 0 0 0-.385-.82Z"
  />
);
